import React from 'react';
import { translateResourceString } from '../../../util/translationUtility';

export default ({
    Type,
    Title,
    Date,
    Description,
    Image,
    Url
}) => {
    const imageStyle = Image && Image !== "null" ? { backgroundImage: `url(${Image})` } : {};
    return (
        <div className="press-release__item col-lg-4 col-6 article-search__item neo-center-preview__wrapper mb-4">
            <div className="neo-center-preview">
                <div className="neo-center-preview__image" style={imageStyle}>
                    <a href={Url}
                        title={Title}
                        className="neo-center-preview__image-link"></a>
                </div>
                <div className="neo-center-preview__body">
                    <a href={Url}
                        className="neo-center-preview__title">{Title}</a>
                    <div className="neo-center-preview__date">{Date}</div>
                    <div className="neo-center-preview__text">
                        <div className="js-truncate" dangerouslySetInnerHTML={{ __html: Description }} />
                    </div>
                    <a className="neo-center-preview__link" href={Url}>{translateResourceString("/NeoCenter/ListingPage/ReadArticle")}</a>
                </div>
            </div>
        </div>
    )
};